module.exports = __webpack_public_path__ + "img/infoPublish.6a1bd950.svg";